import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { Injectable, Optional, InjectionToken, Inject } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SolicitacaoRenovacao } from '../models/solicitacao-renovacao.model';
import { Configuration } from '@app/features-modules/bolsa-de-profissionais/api';

// Define BASE_PATH as an InjectionToken
export const BASE_PATH = new InjectionToken<string>('BASE_PATH');

@Injectable({
  providedIn: 'root',
})
export class SolicitacaoRenovacaoService {
  private readonly path = 'bolsa';
  protected basePath = '/bolsa';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder!: HttpParameterCodec;

  constructor(
    private apiService: ApiService,
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {}

  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  // List all SolicitacaoRenovacao
  list(params: any): Observable<any> {
    return this.apiService
      .get<{ data: SolicitacaoRenovacao[] }>(
        `${this.path}/solicitacao-renovacao`,
        new HttpParams({ fromObject: params })
      )
      .pipe(map((response) => response));
  }

  // Get SolicitacaoRenovacao by ID
  public show(id: string): Observable<SolicitacaoRenovacao> {
    return this.apiService
      .get<{ data: SolicitacaoRenovacao }>(
        `${this.path}/solicitacao-renovacao/${id}`
      )
      .pipe(map((response) => response.data));
  }

  // Create new SolicitacaoRenovacao
  public store(
    solicitacaoRenovacao: SolicitacaoRenovacao
  ): Observable<SolicitacaoRenovacao> {
    return this.apiService
      .post<{ object: SolicitacaoRenovacao }>(
        `${this.path}/solicitacao-renovacao`,
        solicitacaoRenovacao
      )
      .pipe(map((response) => response.object));
  }

  // Update existing SolicitacaoRenovacao
  public update(
    solicitacaoRenovacao: SolicitacaoRenovacao
  ): Observable<SolicitacaoRenovacao> {
    return this.apiService
      .put<{ object: SolicitacaoRenovacao }>(
        `${this.path}/solicitacao-renovacao`,
        solicitacaoRenovacao
      )
      .pipe(map((response) => response.object));
  }

   public updateParecer(
    solicitacaoRenovacao: SolicitacaoRenovacao
  ): Observable<SolicitacaoRenovacao> {
    return this.apiService
      .put<{ object: SolicitacaoRenovacao }>(
        `${this.path}/solicitacao-renovacao/Parecer`,
        solicitacaoRenovacao
      )
      .pipe(map((response) => response.object));
  }

  // Delete existing SolicitacaoRenovacao
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/solicitacao-renovacao/${id}`);
  }

  public solicitacaoRenovacaoPost(
    solicitacao?: string,
    files?: Array<Blob>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public solicitacaoRenovacaoPost(
    solicitacao?: string,
    files?: Array<Blob>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public solicitacaoRenovacaoPost(
    solicitacao?: string,
    files?: Array<Blob>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public solicitacaoRenovacaoPost(
    solicitacao?: string,
    files?: Array<Blob>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: undefined;
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined =
      options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected =
        this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected
      );
    }

    let localVarHttpContext: HttpContext | undefined =
      options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined =
      options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['multipart/form-data'];

    const canConsumeForm = this.canConsumeForm(consumes);

    let localVarFormParams: { append(param: string, value: any): any };
    let localVarUseForm = false;
    let localVarConvertFormParamsToString = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
    localVarUseForm = canConsumeForm;
    if (localVarUseForm) {
      localVarFormParams = new FormData();
    } else {
      localVarFormParams = new HttpParams({ encoder: this.encoder });
    }

    if (solicitacao !== undefined) {
      localVarFormParams =
        (localVarFormParams.append('solicitacao', <any>solicitacao) as any) ||
        localVarFormParams;
    }
    if (files) {
      files.forEach((element) => {
        localVarFormParams =
          (localVarFormParams.append('files', <any>element) as any) ||
          localVarFormParams;
      });
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/solicitacao-renovacao`;
    return this.httpClient.request<any>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: localVarConvertFormParamsToString
          ? localVarFormParams.toString()
          : localVarFormParams,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }
}
function CustomInject(
  BASE_PATH: any
): (
  target: typeof SolicitacaoRenovacaoService,
  propertyKey: undefined,
  parameterIndex: 2
) => void {
  throw new Error('Function not implemented.');
}
